import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className="button--add" icon='add'>{ children ? children : 'Add' }</Button>
}